module.exports = __webpack_public_path__ + "static/media/8.Trumpet call.eb01995a.mp3";